import React from "react";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";

const LogoBanner = ({ content }) => {
  const isTablet = useMediaQuery({ query: "(max-width: 992px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const columnsNumber = items => `repeat(${items.length === 2 ? 2 : items.length / 2}, 1fr`;

  const settings = {
    dots: true,
    arrows: false,
    speed: 500,
    autoplaySpeed: 3000,
    autoplay: true,
    slidesToShow: content.list.length <= 8 ? (isMobile ? 2 : 3) : 3,
    slidesToScroll: content.list.length <= 8 ? (isMobile ? 2 : 3) : 3,
    rows: content.list.length <= 2 ? 1 : 2,
    infinite: true,
    draggable: true
  };

  return (
    <div id="logoBanner">
      {isTablet ? (
        <Slider {...settings}>
          {content.list.map((image, i) => {
            return (
              <div key={i} className="logo">
                <LazyLoadImage alt="logo" height="50" effect="blur" src={image.media?.url} width="150" />
              </div>
            );
          })}
        </Slider>
      ) : (
        <div className="grid" style={{ gridTemplateColumns: columnsNumber(content.list) }}>
          {content.list.map((image, i) => (
            <LazyLoadImage key={i} alt="logo" height="50" effect="blur" src={image.media?.url} width="150" />
          ))}
        </div>
      )}
    </div>
  );
};

export default LogoBanner;
